import { KeyValueStore } from "./key-value/key-value-store";
import { MapViewerConfiguration } from "../config/map-viewer-configuration";
import { ProjectStore } from "./project/project-store";
import { DataTransporter } from "./data-transporter";
import { ContactStore } from "./contact/contact-store";
import { CompensationStore } from "./compensation/compensation-store";
import { UserStore } from "./user/user-store";
import { AuthenticationStore } from "./authentication/authentication-store";
import { ActivityLogEntryStore } from "./activity-log-entry/activity-log-entry-store";
import { AreaStore } from "./area/area-store";
import { MunicipalityStore } from "./municipality/municipality-store";

export class RootStore {
    private session_: RootStoreSession;
    readonly mapViewerConfig: MapViewerConfiguration
    readonly dataTransporter: DataTransporter;
    readonly keyValueStore: KeyValueStore;
    readonly authenticationStore: AuthenticationStore;

    constructor(mapViewerConfig: MapViewerConfiguration) {
        this.dataTransporter = new DataTransporter();
        this.mapViewerConfig = mapViewerConfig;
        this.keyValueStore = new KeyValueStore(mapViewerConfig);
        this.authenticationStore = new AuthenticationStore(mapViewerConfig, this.dataTransporter);
    }

    newSession(): RootStoreSession {
        this.session_ = new RootStoreSession(this, this.dataTransporter);
        return this.session_;
    }

    get session(): RootStoreSession {
        if (this.session_ === undefined) {
            return this.newSession();
        }

        return this.session_;
    }
}

export class RootStoreSession {
    private readonly rootStore: RootStore;
    readonly municipalityStore: MunicipalityStore;
    readonly projectStore: ProjectStore;
    readonly compensationStore: CompensationStore;
    readonly areaStore: AreaStore;
    readonly contactStore: ContactStore;
    readonly userStore: UserStore;
    readonly activityLogEntryStore: ActivityLogEntryStore;

    constructor(rootStore: RootStore, dataTransporter: DataTransporter) {
        this.rootStore = rootStore;
        this.municipalityStore = new MunicipalityStore(dataTransporter);
        this.projectStore = new ProjectStore(rootStore.mapViewerConfig, this, dataTransporter);
        this.compensationStore = new CompensationStore(rootStore.mapViewerConfig, this, dataTransporter);
        this.areaStore = new AreaStore(rootStore.mapViewerConfig, this, dataTransporter);
        this.contactStore = new ContactStore(rootStore.mapViewerConfig, dataTransporter);
        this.userStore = new UserStore(rootStore.mapViewerConfig, dataTransporter);
        this.activityLogEntryStore = new ActivityLogEntryStore(rootStore.mapViewerConfig, dataTransporter);
    }

    get keyValueStore(): KeyValueStore {
        return this.rootStore.keyValueStore;
    }

    get authenticationStore(): AuthenticationStore {
        return this.rootStore.authenticationStore;
    }
}